import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import { Rate, Select, Switch } from "antd";
import {
  capitalizeFirstLetter,
  checkUndefine,
} from "../../../../../../helpers/functions";
import DEFINE, {
  HOMESTAY,
  UPLOAD_DIRECTORY,
  DETAIL_ACTIONS,
} from "../../../../../../constants/Define";
import {
  FormWrapperItem,
  FormWrapperInputComponent,
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import TextArea from "../../../../common/component/TextArea";
import Wrapper from "../../../../common/component/Wrapper";
import UploadImage from "../../../../common/component/UploadImage";
import RichTextEditor, {
  ClassicEditor,
} from "../../../../common/component/RichTextEditor";
import { cloneDeep, get } from "lodash";

import "./styles.less";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";

class BasicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amenities: [],
      dataAmenity: [],
    };
    this.descriptionInputRef = React.createRef();
  }

  static active(props, state) {
    if (props.amenities !== state.amenities) {
      const newAmenities = props.amenities.filter((item) => item.isActive);
      const newGolfAmenity = props.golf.amenity
        ? props.golf.amenity.filter((item) =>
            newAmenities.find((i) => i.id === item)
          )
        : [];
      return {
        amenities: newAmenities,
        dataAmenity: newGolfAmenity,
      };
    }
    return null;
  }

  onChangeImagesOrder = (e) => {
    const media = cloneDeep(this.props.golf?.media || []);
    const newMedia = media
      .map((x) => {
        return {
          ...x,
          order: e.findIndex((y) => y.endsWith(x.url)),
        };
      })
      .sort((a, b) => a.order - b.order);
    this.props.onChange("media", newMedia);
  };

  render() {
    const { t, golf, uploading, disabled, validation, action } = this.props;
    const { amenities, dataAmenity } = this.state;
    return (
      <Wrapper className="basic-info-section">
        <h3 className={`ml-3`}>{t("item.golf.basicInfo")}</h3>
        <FormWrapperItem>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              labelTitle={t(`item.golf.images`)}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <UploadImage
                multiple={true}
                loading={uploading}
                thumbnailSize={120}
                buttonSize={120}
                disabledUpload={disabled}
                disabledRemove={disabled}
                uploadText={t("item.golf.uploadFile")}
                loadingText={t("item.golf.uploading")}
                onChange={this.props.onUploadImage}
                onRemoveThumbnail={this.props.onRemoveImage}
                thumbnails={this.getThumbSources(golf.media || [])}
                allowChangeOrder={true}
                onChangeOrder={this.onChangeImagesOrder}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={golf.name}
              validation={validation.name}
              labelTitle={t(`item.golf.name`)}
            >
              <Input
                placeholder=""
                type={`text`}
                className={`form-control`}
                name={`name`}
                onChange={(e) => this.props.onChange("name", e.target.value)}
                value={checkUndefine(golf.name)}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-6">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={golf.code}
              validation={validation.code}
              labelTitle={t(`item.golf.code`)}
              visible={action !== DETAIL_ACTIONS.TRANSLATE}
            >
              <Input
                placeholder=""
                type={`text`}
                className={`form-control`}
                name={`code`}
                onChange={(e) => this.props.onChange("code", e.target.value)}
                value={checkUndefine(golf.code)}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                labelTitle={t(`item.golf.hotline`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                isRequired={true}
                isValidation={true}
                dataValidation={golf.hotline}
                validation={validation.hotline}
              >
                <Input
                  placeholder=""
                  type={`text`}
                  className={`form-control`}
                  name={`hotline`}
                  onChange={this.onPhoneChange}
                  value={golf.hotline}
                />
              </FormWrapperInputComponent>
            </Wrapper>
          <Wrapper className="col-md-9">
              <FormWrapperInputComponent
                isRequired={false}
                isValidation={false}
                dataValidation={golf.email}
                validation={validation.email}
                labelTitle={t(`item.golf.email`)}
                visible={action !== DETAIL_ACTIONS.TRANSLATE}
              >
                <Input
                  type={`text`}
                  className={`form-control`}
                  name={`email`}
                  onChange={(e) => this.props.onChange("email", e.target.value)}
                  value={checkUndefine(golf.email)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

          <Wrapper className="col-md-3">
            <FormWrapperInputComponent
              className={`d-flex align-items-center justify-content-between flex-column`}
              isRequired={true}
              isValidation={true}
              dataValidation={golf.supportPayLater}
              labelTitle={t(`item.golf.supportPayLater`)}
            >
              <Switch
                onChange={(checked) =>
                  this.props.onChange("supportPayLater", checked)
                }
                checked={golf.supportPayLater}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              isRequired={true}
              isValidation={true}
              dataValidation={golf.website}
              validation={validation.website}
              labelTitle={t(`item.golf.website`)}
            >
              <Input
                placeholder=""
                type={`text`}
                className={`form-control`}
                name={`website`}
                onChange={(e) => this.props.onChange("website", e.target.value)}
                value={golf.website}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent
              labelTitle={t(`item.golf.shortDescription`)}
            >
              <TextArea
                className="form-control"
                name="shortDescription"
                onChange={(e) =>
                  this.props.onChange(
                    "shortDescription",
                    e.target.value.trimLeft()
                  )
                }
                value={golf.shortDescription}
              />
            </FormWrapperInputComponent>
          </Wrapper>
          <Wrapper className="col-md-12">
            <FormWrapperInputComponent labelTitle={t(`item.golf.description`)}>
              <RichTextEditor
                ref={this.descriptionInputRef}
                disabled={disabled}
                editor={ClassicEditor}
                data={golf.description}
                config={{ uploadDirectory: UPLOAD_DIRECTORY.GOLF }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  return this.props.onChange("description", data);
                }}
              />
            </FormWrapperInputComponent>
          </Wrapper>
        </FormWrapperItem>
      </Wrapper>
    );
  }

  getThumbSources(thumbs) {
    return (thumbs || [])
      .filter((t) => t && Object.keys(t).length > 0)
      .map((t) =>
        t.url && t.url.startsWith("http")
          ? t.url
          : `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`
      );
  }

  onPhoneChange = (event) => {
    const phoneStr = event.target.value;
    const regex = /^[0-9\(\)\+\s]*$/;
    if (!phoneStr || regex.test(phoneStr))
      this.props.onChange("hotline", phoneStr);
  };
  setDescription = (description) => {
    if (
      this.descriptionInputRef.current &&
      get(this.descriptionInputRef.current, "editor.setData") &&
      description
    ) {
      return this.descriptionInputRef.current.editor.setData(description);
    }
  };
}

BasicInfo.defaultProps = {
  onChange: () => {},
  action: DETAIL_ACTIONS.CREATE,
};

export default withTranslation(undefined, { withRef: true })(BasicInfo);
